var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchedSocket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 1.28,
    className: "st2",
    width: 0.5,
    height: 13.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.81,12.99l-0.04-0.5C7.23,12.3,9.13,10.14,9,7.68C8.81,5.41,6.95,3.61,4.67,3.49l0.03-0.5 c2.53,0.13,4.59,2.13,4.8,4.65C9.64,10.39,7.54,12.78,4.81,12.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.32,
    y: 7.75,
    className: "st2",
    width: 2.14,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "12.93,12.26 12.44,12.14 12.83,10.54 9.03,9.7 9.13,9.22 13.44,10.17  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchedSocket);
export default __webpack_public_path__ + "static/media/SwitchedSocket.0796470dd43ef33531e3420ab62051b8.svg";
export { ForwardRef as ReactComponent };